import styled from 'styled-components';

export const HelpText = styled.p`
  margin-top: 0.5rem;
`;

export const HelpLink = styled.a`
  margin: 0 0.5rem;
`;
